<nav class="relative z-[100] w-full bg-slate-900 text-slate-100 shadow-sm">
  <ng-template #profileMenu>
    <div class="overflow-hidden rounded-xl border border-slate-200 bg-white text-slate-900 shadow-xl shadow-slate-900/10">
      <div class="flex min-w-0 items-start gap-3 border-b border-slate-100 bg-slate-50 px-4 py-4">
        <span class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-slate-900 text-sm font-semibold text-white" aria-hidden="true">{{ userInitials }}</span>
        <div class="min-w-0 flex-1">
          <p class="m-0 truncate text-sm font-semibold leading-5 text-slate-900" [title]="userName">{{ userName || 'Account' }}</p>
          <p class="m-0 mt-0.5 break-all text-xs leading-5 text-slate-500" [title]="email">{{ email }}</p>
        </div>
      </div>
      <div class="p-2">
        <a *ngIf="typeOfUser === usersGroup.mister"
           class="flex min-h-[44px] w-full items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium !text-slate-700 hover:bg-slate-100 hover:!text-slate-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary"
           [routerLink]="['/reserved-area']" (click)="hideProfilePopup(); closeMobileMenu()">
          <svg class="h-[18px] w-[18px] shrink-0 text-slate-500" fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="8" r="3"/><path stroke-linecap="round" d="M5 20a7 7 0 0 1 14 0"/></svg>
          <span>Area riservata</span>
        </a>
        <a *ngIf="isShopEnabled && typeOfUser !== usersGroup.companyManager"
           class="flex min-h-[44px] w-full items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium !text-slate-700 hover:bg-slate-100 hover:!text-slate-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary"
           [routerLink]="['/shop/cart']" (click)="hideProfilePopup(); closeMobileMenu()">
          <svg class="h-[18px] w-[18px] shrink-0 text-slate-500" fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M3 4h2l2.1 10.2a2 2 0 0 0 2 1.6h8.2a2 2 0 0 0 2-1.6L21 7H6"/><circle cx="10" cy="20" r="1"/><circle cx="18" cy="20" r="1"/></svg>
          <span>Carrello</span>
          <span *ngIf="getCartQuantity() > 0" class="ml-auto inline-flex min-w-[20px] items-center justify-center rounded-full bg-slate-100 px-1.5 py-0.5 text-xs font-semibold text-slate-700">{{ getCartQuantity() }}</span>
        </a>
        <a *ngIf="typeOfUser === usersGroup.companyManager"
           class="flex min-h-[44px] w-full items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium !text-slate-700 hover:bg-slate-100 hover:!text-slate-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary"
           [routerLink]="['/companies/' + currentCompanyId + '/settings']" (click)="setActiveMenu(2); hideProfilePopup(); closeMobileMenu()">
          <svg class="h-[18px] w-[18px] shrink-0 text-slate-500" fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M4 7h16M4 17h16M8 4v6m8 4v6"/></svg>
          <span>Impostazioni società</span>
        </a>
        <a class="flex min-h-[44px] w-full items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium !text-slate-700 hover:bg-slate-100 hover:!text-slate-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary"
           [routerLink]="['/reset-password']" (click)="hideProfilePopup(); closeMobileMenu()">
          <svg class="h-[18px] w-[18px] shrink-0 text-slate-500" fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="10" width="14" height="11" rx="2"/><path stroke-linecap="round" d="M8 10V7a4 4 0 0 1 8 0v3"/></svg>
          <span>Cambia password</span>
        </a>
      </div>
      <div class="border-t border-slate-100 p-2">
        <button type="button" class="flex min-h-[44px] w-full items-center gap-3 rounded-lg border-0 bg-transparent px-3 py-2 text-left text-sm font-medium text-red-700 hover:bg-red-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-red-600" (click)="logout($event)">
          <svg class="h-[18px] w-[18px] shrink-0" fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="M10 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h4M15 16l4-4-4-4m4 4H9"/></svg>
          <span>Esci</span>
        </button>
      </div>
    </div>
  </ng-template>

  <!-- Dropdown backdrop + panel (click-based, fixed position) -->
  <ng-container *ngIf="openDropdownMenuIndex !== null && dropdownPosition && openDropdownItem">
    <div
      class="fixed inset-0 z-[9999]"
      (click)="closeDropdownBackdrop()"
      aria-hidden="true"
    ></div>
    <div
      class="fixed z-[10000] mt-2 w-64 rounded-xl bg-white text-slate-900 shadow-lg border border-slate-100 py-2 max-h-[80vh] overflow-y-auto"
      [style.top.px]="dropdownPosition.top"
      [style.left.px]="dropdownPosition.left"
      (click)="$event.stopPropagation()"
    >
      <ul class="!mb-0 !pl-0">
        <li
          *ngFor="let child of (openDropdownItem.children || [])"
        >
          <a
            class="block w-full text-left px-4 py-2 text-sm text-slate-900 no-underline hover:bg-slate-100 cursor-pointer"
            [attr.href]="child.path.join('/')"
            (click)="navigateToChild(child, openDropdownItem); $event.preventDefault()"
          >
            {{ child.label }}
          </a>
        </li>
      </ul>
    </div>
  </ng-container>

  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div class="flex items-center justify-between h-14 lg:h-16">
      <!-- Left: logo + desktop navigation -->
      <div class="flex items-center gap-6 flex-1">
        <!-- Logo -->
        <a class="flex items-center gap-2 flex-shrink-0">
          <img [src]="navbarLogoUrl" alt="logo" class="h-8 w-auto" />
        </a>

        <!-- Desktop navigation -->
        <div class="hidden lg:flex flex-1 items-center justify-between gap-4">
        <ul class="flex items-center gap-4 text-sm font-medium whitespace-nowrap !mb-0">
          <li *ngFor="let item of filteredNavItems">
            <!-- Simple link -->
            <ng-container *ngIf="!item.children?.length">
              <a
                class="px-3 py-2 rounded-md transition-colors"
                [ngClass]="{
                  'text-white bg-slate-800': activeMenu === item.menuIndex,
                  'text-slate-300 hover:text-white hover:bg-slate-800/60':
                    activeMenu !== item.menuIndex
                }"
                [attr.aria-current]="activeMenu === item.menuIndex ? 'page' : null"
                [routerLink]="getItemRoute(item)"
                [queryParams]="item.queryParams || null"
                (click)="setActiveMenu(item.menuIndex); closeMobileMenu()"
              >
                {{ item.label }}
              </a>
            </ng-container>
            <!-- Dropdown (e.g. Iscrizioni, Shop) - click to open -->
            <ng-container *ngIf="item.children?.length">
              <button
                type="button"
                class="px-3 py-2 rounded-md transition-colors block w-full text-left text-inherit bg-transparent border-0 cursor-pointer font-medium"
                [ngClass]="{
                  'text-white bg-slate-800': activeMenu === item.menuIndex || openDropdownMenuIndex === item.menuIndex,
                  'text-slate-300 hover:text-white hover:bg-slate-800/60':
                    activeMenu !== item.menuIndex && openDropdownMenuIndex !== item.menuIndex
                }"
                (click)="toggleDropdown(item, $event)"
              >
                {{ item.label }}
              </button>
            </ng-container>
          </li>
        </ul>

        <!-- Account menu -->
        <div class="relative ml-4 flex shrink-0 items-center" data-profile-menu>
          <button type="button" class="flex min-h-[44px] items-center gap-2 rounded-lg border-0 bg-transparent px-2 text-slate-200 hover:bg-slate-800 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-400"
                  [attr.aria-label]="showPopup ? 'Chiudi menu account' : 'Apri menu account'" aria-controls="desktop-profile-menu" [attr.aria-expanded]="showPopup"
                  (click)="toggleProfilePopup()">
            <span class="flex h-9 w-9 items-center justify-center rounded-full border border-slate-600 bg-slate-700 text-xs font-semibold text-white" aria-hidden="true">{{ userInitials }}</span>
            <svg class="h-4 w-4 text-slate-400" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" d="m6 9 6 6 6-6"/></svg>
          </button>
          <div *ngIf="showPopup" id="desktop-profile-menu" class="absolute right-0 top-full z-[200] w-72 max-w-[calc(100vw-1rem)] pt-2">
            <ng-container *ngTemplateOutlet="profileMenu"></ng-container>
          </div>
        </div>
      </div>

      <!-- Right section on mobile: profile + burger -->
      <div class="flex items-center lg:hidden ml-auto">
        <!-- Account menu -->
        <div class="relative" data-profile-menu>
          <button type="button" class="flex h-11 w-11 items-center justify-center rounded-lg border-0 bg-transparent hover:bg-slate-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-teal-400"
                  [attr.aria-label]="showPopup ? 'Chiudi menu account' : 'Apri menu account'" aria-controls="mobile-profile-menu" [attr.aria-expanded]="showPopup"
                  (click)="toggleProfilePopup()">
            <span class="flex h-9 w-9 items-center justify-center rounded-full border border-slate-600 bg-slate-700 text-xs font-semibold text-white" aria-hidden="true">{{ userInitials }}</span>
          </button>
          <div *ngIf="showPopup" id="mobile-profile-menu" class="absolute -right-12 top-full z-[200] w-72 max-w-[calc(100vw-1rem)] pt-2">
            <ng-container *ngTemplateOutlet="profileMenu"></ng-container>
          </div>
        </div>

        <!-- Mobile menu button -->
        <button
          type="button"
          class="inline-flex items-center justify-center p-2 rounded-lg text-slate-300 hover:text-white hover:bg-slate-800/70 transition-colors"
          (click)="toggleMobileMenu()"
          aria-label="Toggle menu"
        >
          <svg
            *ngIf="!mobileMenuOpen"
            class="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 6h16M4 12h16M4 18h16"
            ></path>
          </svg>
          <svg
            *ngIf="mobileMenuOpen"
            class="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            ></path>
          </svg>
        </button>
      </div>
    </div>

    <!-- Mobile navigation menu / sidebar -->
    <div
      class="lg:hidden origin-top transition-all duration-200 ease-out absolute inset-x-0 top-14 bg-slate-900/95 backdrop-blur-sm border-t border-slate-800 z-50"
      [ngClass]="{
        'opacity-0 pointer-events-none': !mobileMenuOpen,
        'opacity-100 pointer-events-auto': mobileMenuOpen
      }"
    >
      <div class="pt-3 pb-4">
        <ul class="flex flex-col gap-1 text-sm font-medium text-slate-100 !mb-0">
          <li *ngFor="let item of filteredNavItems">
            <a
              class="block w-full px-3 py-2 rounded-md"
              [ngClass]="{
                'bg-slate-800 text-white': activeMenu === item.menuIndex,
                'text-slate-300 hover:bg-slate-800/60 hover:text-white':
                  activeMenu !== item.menuIndex
              }"
              [routerLink]="getItemRoute(item)"
              [queryParams]="item.queryParams || null"
              (click)="setActiveMenu(item.menuIndex); closeMobileMenu()"
            >
              {{ item.label }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
